var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "container",
      staticStyle: { "flex-direction": "row", flex: "1" }
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.showLeft,
              expression: "showLeft"
            }
          ],
          ref: "left",
          style: Object.assign(
            { flex: "auto", overflow: "hidden" },
            _vm.leftStyle
          )
        },
        [_vm._t("left")],
        2
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.showLeft && _vm.showRight,
              expression: "showLeft&&showRight"
            }
          ],
          ref: "division",
          staticClass: "division",
          style: { width: _vm.divisionW + "px" },
          on: {
            mousedown: function($event) {
              _vm.enabled = true
            }
          }
        },
        [_c("span", [_vm._v("‖")])]
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.showRight,
              expression: "showRight"
            }
          ],
          ref: "right",
          style: Object.assign(
            { flex: "auto", overflow: "hidden" },
            _vm.rightStyle
          )
        },
        [_vm._t("right")],
        2
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }